import styled from 'styled-components';

/**
 * this is the label above TextField, TextArea, etc.
 */
export const FormLabel = styled.label`
  display: block;
  width: 100%;
  color: ${props => props.theme.textLabel};
  font-size: 0.875em;
  font-weight: bold;
  line-height: 1.063em;
  padding-bottom: 0.5em;
  font-family: 'Lato', sans-serif;
`;
